module.exports = __webpack_public_path__ + "img/en_structureChartexample.b2263150.svg";